import React, { useEffect, useState } from 'react'
import nbrApi from '../../../services/nbrApi'
import { Link, useNavigate } from 'react-router-dom'

function PropertyList() {
    const [data, setData] = useState([])
    const navigate = useNavigate()

    // fetch data 
    async function fetchList() {
        try {
            const response = await nbrApi.post('/listproperties')

            const data = response.data
            setData(data)
        } catch (error) {
            console.error('Error fetching data:', error.message)
        }
    }

    // CreatePrroperty
    const handleCreatePrroperty = () => {
        navigate('/properties-create')
    }

    // Init
    useEffect(() => {
        fetchList()
    }, [])

    // render
    return (
        <div className="row">
            <div className="col-xxl-12">
                <div className="card">
                    <div className="card-header">
                        <h4 className="heading me-2">Properties List</h4>
                        <button type='button' onClick={handleCreatePrroperty} className='btn btn-primary btn-sm'>Create New Property</button>
                    </div>

                    <div className="card-body">
                        {data?.length === 0 &&
                            <p className='alert alert-primary fw-bold'>No Data available !</p>}
                        {data?.length > 0 && <div className="table-responsive dataTablehistory">
                            <div className="dataTables_wrapper no-footer">
                                <table id="example" className="table shadow-hover dataTable display">
                                    <thead>
                                        <tr className='text-left'>
                                            <th>ID</th>
                                            <th>Region</th>
                                            <th>Property Name</th>
                                            <th>Property Description</th>
                                            <th>City</th>
                                            <th>State</th>
                                            <th>UTC Offset</th>
                                            <th>Status</th>
                                            <th className="text-end">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data?.map((item, index) => (
                                            <tr key={index} className='text-black text-capitalize'>
                                                <td>{item?.pk_id}</td>
                                                <td>{item?.regions_id}</td>
                                                <td>{item?.property_name}</td>
                                                <td>{item?.property_description}</td>
                                                <td>{item?.property_city}</td>
                                                <td>{item?.property_state}</td>
                                                <td>{item?.local_utc_offset}</td>
                                                <td>{item?.status_val}</td>
                                                <td className="text-end">
                                                    <div className="d-flex justify-content-end">
                                                        <Link to={{ pathname: '/properties-edit/' + item?.pk_id, state: item }} className="btn btn-primary shadow btn-xs sharp me-3"><i className="fas fa-pencil-alt"></i></Link>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PropertyList